export const indicator = {
    title: {
        visible: !0,
        autoLimit: !1,
        autoFit: !1,
        style: {
            fontSize: {
                type: "token",
                key: "l1FontSize"
            },
            fill: {
                type: "palette",
                key: "primaryFontColor"
            },
            fontWeight: "normal",
            fillOpacity: 1,
            textBaseline: "top",
            textAlign: "center"
        }
    },
    content: {
        visible: !0,
        style: {
            fontSize: {
                type: "token",
                key: "l2FontSize"
            },
            fill: {
                type: "palette",
                key: "tertiaryFontColor"
            },
            fontWeight: "normal",
            fillOpacity: 1,
            textBaseline: "top",
            textAlign: "center"
        }
    }
};
//# sourceMappingURL=indicator.js.map
